import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-name-value-list-entry",
    styleUrls: ["./name-value-list-entry.component.scss"],
    templateUrl: "./name-value-list-entry.component.html",
    standalone: false
})
export class FUINameValueListEntryComponent {
    @Input() name: string;
    @Input() value: string;
}
